
export function timestampToTime(row) {
    if (isNaN(row)) {
        return "";
    }
    var now = new Date();
    var year = now.getFullYear(); //得到年份
    var date = new Date(row); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear();
    var M =
        (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
    var D = "";
    if (String(date.getDate()).length <= 1) {
        D = "0" + date.getDate() + " ";
    } else {
        D = date.getDate() + " ";
    }
    var hour = now.getHours(); //当前时间的小时数
    var minute = now.getMinutes(); //当前时间分钟数
    var h = date.getHours(); //评论时间的小时数
    var m = date.getMinutes(); //评论时间的分钟数
    var s = date.getSeconds();
    if (year == Y) {
        if (hour == h) {
            if (minute - m <= 1) {
                return "刚刚";
            } else {
                return M + D;
            }
        } else {
            return M + D;
        }
    } else {
        return Y + "-" + M + D;
    }
}

/**
 * 
 * @param {} row 
 */
export function timestampToTimeForActivity(row, str) {
    if (isNaN(row)) {
        return "";
    }
    let now = new Date();
    let year = now.getFullYear(); //得到年份
    let mounth = (now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1) + "-";
    let day = "";
    let hour = now.getHours(); //当前时间的小时数
    let minute = now.getMinutes(); //当前时间分钟数

    if (String(now.getDate()).length <= 1) {
        day = "0" + now.getDate() + " ";
    } else {
        day = now.getDate() + " ";
    }
    let date = new Date(row); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear();
    let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + ".";
    let D = "";
    if (String(date.getDate()).length <= 1) {
        D = "0" + date.getDate() + "";
    } else {
        D = date.getDate() + " ";
    }
    if (str == 'feedBack' || str == 'commentList') {
        M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "月";
        D = "";
        if (String(date.getDate()).length <= 1) {
            D = "0" + date.getDate() + "日";
        } else {
            D = date.getDate() + "日";
        }
    }
    let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //
    let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(); //
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    if (str == 'feedBack' || str == 'commentList') {
        if (Y !== new Date().getFullYear()) {
            return `${Y}年${M}${D} ${h}:${m}:${s}`;

        } else {
            if (year == Y) {
                if (hour == h) {
                    if (minute - m <= 1) {
                        return "刚刚";
                    } else {
                        return `${M}${D} ${h}:${m}:${s}`;
                    }
                } else {
                    return `${M}${D} ${h}:${m}:${s}`;
                }
            } else {
                return `${M}${D} ${h}:${m}:${s}`;
            }


        }
    } else {
        return `${M}${D}`;
    }


}

/**
 *  将时间戳变为自定义需要样子
 * @param {时间戳} row 
 */
export function timestampToTimeText(row) {
    if (isNaN(row)) {
        return "";
    }
    var now = new Date();
    var year = now.getFullYear(); //得到年份
    var mounth = (now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1) + "-";
    var day = "";
    var hour = now.getHours(); //当前时间的小时数
    var minute = now.getMinutes(); //当前时间分钟数

    if (String(now.getDate()).length <= 1) {
        day = "0" + now.getDate() + " ";
    } else {
        day = now.getDate() + " ";
    }
    var date = new Date(row); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear();
    var M =
        (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
    var D = "";
    if (String(date.getDate()).length <= 1) {
        D = "0" + date.getDate() + " ";
    } else {
        D = date.getDate() + " ";
    }
    var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //评论时间的小时数
    var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(); //评论时间的分钟数
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    if (Y == year && M == mounth && D == day) {
        return `今天 ${h}:${m}`
    }
    return `${Y}-${M}${D} ${h}:${m}`;
}




export function getDistance(lat1, lng1, lat2, lng2) {
    let distance = 0
    // 角度转弧度
    const nlat1 = Number(lat1)
    const nlng1 = Number(lng1)
    const nlat2 = Number(lat2)
    const nlng2 = Number(lng2)
    if (!nlat1 || !nlng1 || !nlat2 || !nlng2) {
        return distance
    }
    const pi180 = Math.PI / 180
    const ew1 = nlng1 * pi180
    const ns1 = nlat1 * pi180
    const ew2 = nlng2 * pi180
    const ns2 = nlat2 * pi180
    // 经度差
    distance = Math.sin(ns1) * Math.sin(ns2) + Math.cos(ns1) * Math.cos(ns2) * Math.cos(ew1 - ew2)
    if (distance > 1.0) {
        distance = 1.0
    } else if (distance < -1.0) {
        distance = -1.0
        // 求大圆劣弧长度
    }
    distance = 6370693.5 * Math.acos(distance);
    distance = distance / 1000;
    if (parseInt(distance) >= 1) {
        return { distance: distance, type: 'km' };
    } else {
        return { distance: distance * 1000, type: 'm' };
    }
}

/**
 * 根据经纬度计算距离  (已废弃:保持与小程序一致)
 * @param {*第一经度} lat1 
 * @param {*第一纬度} lng1 
 * @param {*第二经度} lat2 
 * @param {*第二纬度} lng2 
 */
export function getDistance1(lat1, lng1, lat2, lng2) {
    // console.log(`第一点经纬度:${lat1},${lng1},第二点经纬度:${lat2},${lng2}`);
    var radLat1 = rad(lat1);
    var radLat2 = rad(lat2);
    var a = radLat1 - radLat2;
    var b = rad(lng1) - rad(lng2);
    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137; // EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000; //输出为公里
    var distance = s;
    if (parseInt(distance) >= 1) {
        return { distance: s, type: 'km' };
    } else {
        return { distance: s * 1000, type: 'm' };
    }
    //s=s.toFixed(4);
    // console.info('lyj 距离是', s);
    // console.info('lyj 距离是', distance_str);
    // return s;

}

/**
 * 经纬度转换成三角函数中度分表形式
 * @param {*经度/纬度} d 
 */
function rad(d) {
    return d * Math.PI / 180.0;
}